// src/services/notificationInboxService.js
// In-app notification inbox (bell icon) backed by /api/notifications.
import api from './api';

class NotificationInboxService {
  async list() {
    const res = await api.get('/api/notifications');
    return res.notifications || [];
  }

  async unreadCount() {
    const res = await api.get('/api/notifications/unread-count');
    return res.count || 0;
  }

  async markRead(id) {
    return api.post(`/api/notifications/${id}/read`, {});
  }

  async markAllRead() {
    return api.post('/api/notifications/read-all', {});
  }
}

export const notificationService = new NotificationInboxService();
export default notificationService;
